<template>
  <div style="max-height: 100px">
    <b-modal id="modalCategories" centered hide-header>
      <template #modal-footer>
        <div style="width: 100%; display: flex; justify-content: space-between">
          <button
            class="btnsModal"
            variant="info"
            size="sm"
            @click="handleCloseModalAndClear"
          >
            Fechar
          </button>
          <button
            class="btnsModal btnSave"
            variant="info"
            size="sm"
            @click="saveOrUpdate"
          >
            Salvar
          </button>
        </div>
      </template>
      <div class="mt-3">
        <div class="titleCard">
          <p>Categoria</p>
        </div>
        <div>
          <label style="font-size: 14px; color: #666360">
            Informe abaixo o nome da categoria
          </label>
          <div>
            <Input
              type="text"
              :dataInput.sync="dataCategory.nome"
              ref="categoryName"
            />
          </div>
        </div>

        <table class="table table-sm mt-5">
          <thead>
            <tr style="width: 100%">
              <th style="width: 50%; font-size: 14px; font-weight: 600">
                Nome
              </th>
              <th
                style="
                  width: 50%;
                  text-align: center;
                  font-size: 14px;
                  font-weight: 600;
                  padding: 0 10px;
                "
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="category in dataAllCategory" :key="category.id">
              <td style="font-size: 14px">{{ category.nome }}</td>
              <td
                style="
                  text-align: center;
                  padding: 0 !important;
                  display: flex;
                  height: 100%;
                  justify-content: center;
                  gap: 20px;
                  padding: 0.5rem;
                "
              >
                <b-icon-pencil
                  @click="getCategoryFindById(category.id)"
                  scale="1"
                  role="button"
                />

                <b-icon-x-circle
                  @click="deleteCategory(category.id)"
                  role="button"
                  style="color: red"
                  scale="1"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ServiceCategory from "../../services/serviceCategory";
import Input from "../UI/CustomInputs/Input.vue";

export default {
  data() {
    return {
      dataCategory: {
        id: "",
        nome: "",
      },
      dataAllCategory: [],
    };
  },
  components: {
    Input,
  },
  methods: {
    async saveCategory() {
      try {
        await ServiceCategory.save(this.dataCategory);
        this.getAllCategory();

        this.$emit("getNewCategory");

        return this.$toast.open({
          message: "Salvo com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.erros}` || "Ocorreu um erro o salvar!",
          type: "info",
        });
      }
    },

    async updateCategory() {
      try {
        await ServiceCategory.update(this.dataCategory);
        this.getAllCategory();

        this.$emit("getNewCategory");

        return this.$toast.open({
          message: "Atualizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao deletar!",
          type: "info",
        });
      }
    },

    async deleteCategory(idCategory) {
      try {
        await ServiceCategory.delete(idCategory);
        this.getAllCategory();

        this.$emit("getNewCategory");

        return this.$toast.open({
          message: "deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao deletar!",
          type: "info",
        });
      }
    },

    async getCategoryFindById(idCategory) {
      const result = await ServiceCategory.findById(idCategory);
      Object.assign(this.dataCategory, result);
      this.$refs.categoryName.valueInput = result.nome;
    },

    async getAllCategory() {
      const result = await ServiceCategory.fillComobobox();
      this.dataAllCategory = result;
    },

    async saveOrUpdate() {
      this.dataCategory.id === ""
        ? await this.saveCategory()
        : await this.updateCategory();
      this.clear();
    },

    clear() {
      this.dataCategory.id = "";
      this.dataCategory.nome = "";
      this.$refs.categoryName.valueInput = "";
    },

    handleCloseModalAndClear() {
      this.clear();
      this.$bvModal.hide("modalCategories");
    },
  },
  mounted() {
    this.getAllCategory();
  },
};
</script>

<style scoped>
.styleHoverDelete:hover {
  background-color: #ff6347;
  border: solid 1px black;
}

.tabsContentSearch {
  overflow-y: scroll;
  max-height: 300px;
}

.btnsModal {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  height: 28px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
}

.btnSave {
  background-color: transparent;
  border: solid 1px #0fbf4d;
  color: #0fbf4d;
}

.titleCard {
  margin-bottom: 32px !important;
  font-weight: 600;
  color: #666360;
  font-size: 16px;
}
</style>